import { ErrorBoundary } from 'react-error-boundary';
import { AnimatePresence, motion } from 'framer-motion';
import { useMenuStore } from '../../../stores';
import { MenuDesktopNavBar } from './MenuDesktopNavBar';
import { MenuDesktopPanel } from './MenuDesktopPanel';

export function MenuDesktop() {
  const isMenuOpen = useMenuStore.use.isMenuOpen();

  return (
    <AnimatePresence key="menu-desktop">
      {isMenuOpen && (
        <motion.div
          className="tlw-hidden tlw-absolute tlw-top-full tlw-w-full tlw-max-h-[624px] tlw-bg-white tlw-rounded-b-xl tlw-overflow-hidden lg:tlw-grid lg:tlw-grid-rows-[auto_1fr]"
          initial={{ height: '0' }}
          animate={{ height: '80vh' }}
          exit={{ height: '0' }}
          transition={{ duration: 0.3 }}
        >
          {/* 菜單導航 */}
          <ErrorBoundary fallback={<div>MenuDesktopNavBar</div>}>
            <MenuDesktopNavBar />
          </ErrorBoundary>

          {/* 菜單面板 */}
          <ErrorBoundary fallback={<div>MenuDesktopPanel</div>}>
            <MenuDesktopPanel />
          </ErrorBoundary>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
